import Paragraph from '@tiptap/extension-paragraph';
import { mergeAttributes } from '@tiptap/core';

const DivParagraph = Paragraph.extend({
    parseHTML() {
        return [{ tag: 'p' }, { tag: 'div' }];
    },
    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
});

export default DivParagraph;
